import {Component, OnInit} from '@angular/core';
import {PageHeaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {SharedService} from "../../shared/shared.service";
import {SharedDataService} from "../../shared/shared-data.service";
import {DtoManagementCustomer} from "./models/DtoManagementCustomer";
import {DtoCustomerInfoBaseItems} from "./models/DtoCustomerInfoBaseItems";
import {ManagementCustomerInfoService} from "./management-customer-info.service";
import {Border, SeriesLabels} from "@progress/kendo-angular-charts";

@Component({
    selector: 'app-management-customer-info',
    template: require('./management-customer-info.component.html'),
    styles: [require('./management-customer-info.component.css')]
})

@AutoUnsubscribe()
export class ManagementCustomerInfoComponent implements OnInit {
    periodDisabled: boolean;
    subSalesgroupDisabled: boolean;
    data: DtoManagementCustomer;
    filterHeaderConfig: PageHeaderBarConfig;
    periodItems: Array<{ text: string, value: number }> = [
        {text: "Deze week", value: 1},
        {text: "Deze maand", value: 2},
        {text: "Dit jaar", value: 3},
        {text: "Laatste 2 jaar", value: 4},
        {text: "Variabele periode", value: 5}
    ];
    baseItems: DtoCustomerInfoBaseItems;
    filterForm: FormGroup;
    legendBorder: Border = {
        color: '#bababa',
        dashType: "solid",
        width: 1
    };
    public seriesLabels: SeriesLabels = {
        visible: true,
        padding: 3,
        font: '12px Arial, sans-serif',
        content: e => {return (e.percentage * 100).toFixed(0) + '%'}
    };

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ss: SharedService,
                private sds: SharedDataService,
                private ds: ManagementCustomerInfoService) {
    }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'management', isLastStep: false },
            { text: 'detailgegevens klanten', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
        this.filterHeaderConfig = {
            title: 'INSTELLINGEN',
            buttonDefinition: [
                {
                    description: 'RESULTATEN',
                    clickEventType: 'search',
                    isSmall: false
                }
            ]
        };

        this.filterForm = this.fb.group({
            employeeId: 0,
            userId: 0,
            periodId: 2,
            from: null,
            untill: null
        });


        this.filterForm.get('periodId').valueChanges.subscribe(newVal => {
            this.setFilterPeriod(newVal);
            this.clearData();
        });

        this.filterForm.get('userId').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('employeeId').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('from').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('untill').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.setFilterPeriod(2);

        this.ds.getCustomerInfoBaseItems().subscribe((res: DtoCustomerInfoBaseItems) => {
            this.baseItems = res;
            this.loadData();
        });
    }

    clearData() {
        this.data = null;
    }

    loadData() {
        this.data = null;
        this.ds.getCustomerInfo({
            userId: this.filterForm.get('userId').value,
            from: this.filterForm.get('from').value,
            employeeId: this.filterForm.get('employeeId').value,
            untill: this.filterForm.get('untill').value
        }).subscribe((res: DtoManagementCustomer) => {
            this.data = res;
        });
    }

    setFilterPeriod(periodKind: number) {
        if (periodKind == 1) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.addDaysToDate(this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()), 6) });
        } else if (periodKind == 2) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfMonth(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.getLastDayOfMonth(this.ss.getCurrentDate()) });
        } else if (periodKind == 3) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.getLastDayOfYear(this.ss.getCurrentDate()) });
        } else if (periodKind == 4) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.addYearsToDate(this.ss.getLastDayOfYear(this.ss.getCurrentDate()), 1) });
        } else if (periodKind == 5) {
            this.periodDisabled = false;
        }
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/management/customer-info/management-customer-info.component.ts